import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
 import JoinNowFormPopup from "../../../componants/JoinNowFormPopup";

// Helper component for Star Rating (reused)
const StarRating = ({ rating }: { rating: number }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <svg
        key={i}
        className={`h-4 w-4 ${
          i <= rating ? "text-yellow-400" : "text-gray-300"
        } inline-block`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
      </svg>
    );
  }
  return <div className="flex items-center">{stars}</div>;
};

  
  //  const [selectedCourseTitle, setSelectedCourseTitle] = useState("");
  //  const [isPopupOpen, setIsPopupOpen] = useState(false); 

  // const handleOpenPopup = (courseTitle: string) => {
// Helper component for Verified Badge (reused)
const VerifiedBadge = () => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 ml-2">
    <svg
      className="w-3 h-3 mr-1"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clipRule="evenodd"
      />
    </svg>
    Verified
  </span>
);

const JAVAFullStackInNoida = () => {
  const testimonials = [
    {
      id: 1,
      name: "Ankit Sharma",
      review:
        "The Java Full Stack training at Nadezhda Venture is top-notch! I gained a deep understanding of Spring Boot and Hibernate, which were crucial for securing my first developer role. Highly recommend for aspiring Java developers.",
      rating: 5,
      date: "2024-07-30",
      profileImg: "https://randomuser.me/api/portraits/men/32.jpg", // Placeholder image
      source: "Google Reviews",
    },
    {
      id: 2,
      name: "Pooja Singh",
      review:
        "I came with basic Java knowledge and left as a confident full stack developer. The instructors are incredibly supportive, and the real-time projects truly prepare you for the industry. Best Java Full Stack course in Noida!",
      rating: 4,
      date: "2024-07-28",
      profileImg: "https://randomuser.me/api/portraits/women/45.jpg", // Placeholder image
      source: "LinkedIn",
    },
    {
      id: 3,
      name: "Suresh Kumar",
      review:
        "From Core Java to advanced Spring Boot and microservices, the curriculum covers everything you need. The hands-on approach helped me grasp complex concepts easily. Excellent placement assistance too!",
      rating: 5,
      date: "2024-07-25",
      profileImg: "https://randomuser.me/api/portraits/men/50.jpg", // Placeholder image
      source: "Website Feedback",
    },
    {
      id: 4,
      name: "Ritu Verma",
      review:
        "The emphasis on practical application and industry best practices made this course stand out. I loved learning about integrating React with Spring Boot. Now I feel fully equipped for a full stack role.",
      rating: 5,
      date: "2024-07-23",
      profileImg: "https://randomuser.me/api/portraits/women/60.jpg", // Placeholder image
      source: "Google Reviews",
    },
    {
      id: 5,
      name: "Amit Dubey",
      review:
        "This is hands down the most comprehensive Java Full Stack training available. The modules on REST APIs and deploying applications were particularly insightful. Got placed within a month after finishing!",
      rating: 4,
      date: "2024-07-20",
      profileImg: "https://randomuser.me/api/portraits/men/75.jpg", // Placeholder image
      source: "LinkedIn",
    },
  ];


  const [isPopupOpen, setIsPopupOpen] = useState(false); // State to control popup visibility
    const [selectedCourseTitle, setSelectedCourseTitle] = useState(""); // State to store the course title
  
    const handleOpenPopup = (courseTitle: string) => { // Function to open the popup
      setSelectedCourseTitle(courseTitle); // Set the selected course title
      setIsPopupOpen(true); // Open the popup
    };
  
    const handleClosePopup = () => { // Function to close the popup
      setIsPopupOpen(false); // Close the popup
      setSelectedCourseTitle(""); // Clear selected course when closing
    };

  const faqContent = [
    {
      title: "What is Java Full Stack Development?",
      answer:
        "Java Full Stack Development involves mastering both front-end (user interface, usually HTML, CSS, JavaScript frameworks like React/Angular) and back-end (server, database, APIs using Java frameworks like Spring Boot) technologies. It enables a developer to build and manage an entire web application independently.",
    },
    {
      title: "What are the prerequisites for this Java Full Stack course?",
      answer:
        "A basic understanding of programming concepts is helpful, but our course is designed to start from Core Java fundamentals. We cover everything from scratch, making it suitable for freshers and those looking to switch careers or upskill.",
    },
    {
      title: "What Java technologies will I learn?",
      answer:
        "You will learn Core Java (OOPs, Collections, Exception Handling, Multithreading), Advanced Java (JDBC, Servlets, JSP), Spring Framework (Spring Core, Spring MVC, Spring Boot, Spring Data JPA), Hibernate ORM, and building RESTful APIs. We also cover database management (MySQL/PostgreSQL) and frontend integration (React/Angular overview).",
    },
    {
      title: "Is this course suitable for beginners?",
      answer:
        "Yes, absolutely! Our curriculum is structured to guide you from basic Java concepts to advanced full-stack development, with extensive hands-on practice and projects. No prior full stack experience is necessary.",
    },
    {
      title: "Will I get placement assistance after course completion?",
      answer:
        "Yes, we provide 100% placement assistance, including resume building, mock interviews, soft skills training, and connecting you with our network of hiring companies for Java Full Stack Developer roles in Noida and pan-India.",
    },
    {
      title: "What kind of projects will I work on?",
      answer:
        "You will develop multiple real-world projects, including a major Capstone Project. These projects integrate frontend and backend technologies, allowing you to build complete, functional web applications like e-commerce platforms, content management systems, or enterprise solutions.",
    },
    {
      title: "What are the career opportunities after this training?",
      answer:
        "Upon successful completion, you can pursue roles such as Java Full Stack Developer, Backend Developer, Spring Boot Developer, Enterprise Java Developer, Software Engineer (Java), and Microservices Developer.",
    },
    {
      title: "What is the duration and mode of training?",
      answer:
        "The course duration varies based on the pace and mode (e.g., intensive fast-track vs. regular). We offer both intensive offline classroom training at our Noida center and interactive live online classes, providing flexibility to suit your needs.",
    },
  ];

  const curriculumContent = [
    {
      title: "Module 1: Core Java Programming",
      description: "Fundamentals of Java, OOPs concepts, Data Types, Operators, Control Flow, Arrays, Strings, Exception Handling, Multithreading, Collections Framework, and File I/O.",
    },
    {
      title: "Module 2: Advanced Java (J2EE Fundamentals)",
      description: "JDBC (Java Database Connectivity), Servlets, JSP (JavaServer Pages), Session Management, and developing simple web applications using J2EE components.",
    },
    {
      title: "Module 3: Database Management (SQL & MySQL/PostgreSQL)",
      description: "SQL basics, DDL, DML, DCL commands, Joins, Subqueries, Stored Procedures, and practical experience with MySQL or PostgreSQL database systems.",
    },
    {
      title: "Module 4: ORM with Hibernate & JPA",
      description: "Introduction to ORM, Hibernate framework architecture, Hibernate CRUD operations, JPA annotations, one-to-one, one-to-many, many-to-many mappings, and HQL.",
    },
    {
      title: "Module 5: Spring Framework Core & Spring MVC",
      description: "In-depth Spring Core (IoC, DI), Aspect-Oriented Programming (AOP), Spring MVC architecture, Controllers, Views, Data Binding, and Form Handling.",
    },
    {
      title: "Module 6: Spring Boot & Microservices",
      description: "Building production-ready applications with Spring Boot, Auto-configuration, Starters, Actuator. Introduction to Microservices architecture, creating RESTful APIs with Spring Boot.",
    },
    {
      title: "Module 7: RESTful Web Services",
      description: "Designing and implementing REST APIs using Spring Boot, API versioning, error handling, security (Spring Security), and consuming REST services.",
    },
    {
      title: "Module 8: Frontend Technologies & Integration (React/Angular Basics)",
      description: "Introduction to HTML5, CSS3, JavaScript (ES6+). Overview of a modern frontend framework like React or Angular for building user interfaces and integrating with Java backend APIs.",
    },
    {
      title: "Module 9: Project Management Tools & Version Control",
      description: "Introduction to Maven/Gradle for build automation, Git for version control, and using IDEs like IntelliJ IDEA or VS Code effectively.",
    },
    {
      title: "Module 10: Deployment & Best Practices",
      description: "Containerization basics (Docker), deploying Spring Boot applications to cloud platforms (e.g., AWS, Heroku basics), testing strategies, and industry best practices for robust Java development.",
    },
    {
      title: "Module 11: Capstone Project",
      description: "Develop a complete, real-world full-stack web application from scratch, applying all learned Java, Spring Boot, Hibernate, and frontend integration concepts. This project will be a centerpiece of your portfolio.",
    },
  ];

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  useEffect(() => {
    const autoScrollInterval = setInterval(() => {
      setCurrentTestimonialIndex(
        (prevIndex) => (prevIndex + 1) % testimonials.length
      );
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(autoScrollInterval); // Clean up the interval
  }, [testimonials.length]);

  const goToPrevTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNextTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      (prevIndex + 1) % testimonials.length
    );
  };

  // Determine how many testimonials to show at once (e.g., 1 on small, 2 on medium, 3 on large)
  const getVisibleTestimonialsCount = () => {
    if (window.innerWidth >= 1024) return 3; // lg breakpoint
    if (window.innerWidth >= 768) return 2; // md breakpoint
    return 1; // default for small screens
  };

  const [visibleCount, setVisibleCount] = useState(
    getVisibleTestimonialsCount()
  );

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleTestimonialsCount());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const startIndex = currentTestimonialIndex;
  const currentVisibleTestimonials = [];

  // Logic to handle showing multiple cards and wrapping around
  for (let i = 0; i < visibleCount; i++) {
    currentVisibleTestimonials.push(
      testimonials[(startIndex + i) % testimonials.length]
    );
  }

  // State for the enquiry form
  const [formData, setFormData] = useState({
    firstName: "",
    businessEmail: "",
    phone: "",
    courseOfInterest: "Java Full Stack", // Pre-fill for this page
    collegeName: "",
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    message: "",
    type: "", // 'success' or 'error'
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus({ submitted: false, message: "", type: "" }); // Reset status

    try {
      const response = await fetch("/api2/submit-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          businessEmail: formData.businessEmail,
          phone: formData.phone,
          courseOfInterest: formData.courseOfInterest,
          collegeName: formData.collegeName,
          // You can include other fields from FormSubmissionDto if they are relevant
          // For this specific form, interests, howDidYouFindUs, subscribeNewsletter, message, companyName might not be directly captured.
          // You can send default/empty values for those or omit them if your backend handles missing fields.
          lastName: "N/A", // Default value
          companyName: "N/A", // Default value
          interests: ["Java Full Stack Training"], // Default value
          howDidYouFindUs: "Website Enquiry", // Default value
          subscribeNewsletter: false, // Default value
          message: `Enquiry for ${formData.courseOfInterest} training.`, // Default message
        }),
      });

      if (response.ok) {
        setFormStatus({
          submitted: true,
          message: "Form submitted successfully! You will receive a confirmation email shortly.",
          type: "success",
        });
        setFormData({
            firstName: "",
            businessEmail: "",
            phone: "",
            courseOfInterest: "Java Full Stack",
            collegeName: "",
        }); // Clear form
      } else {
        const errorData = await response.json();
        setFormStatus({
          submitted: true,
          message: `Error submitting form: ${errorData.message || response.statusText}`,
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormStatus({
        submitted: true,
        message: "An unexpected error occurred. Please try again later.",
        type: "error",
      });
    }
  };


  return (
    <div className="bg-white text-gray-800">
      <Helmet>
        <title>Java Full Stack Training in Noida | Spring Boot, Hibernate, React/Angular</title>
        <meta
          name="description"
          content="Master Java Full Stack development in Noida. Our comprehensive training covers Core Java, Spring Boot, Hibernate, REST APIs, and frontend integration with 100% placement assistance."
        />
        <meta
          name="keywords"
          content="Java Full Stack training Noida, Spring Boot course, Hibernate training, Core Java, Advanced Java, REST APIs, Microservices Java, React Java, Angular Java, Java developer jobs Noida, Java placement"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="relative overflow-hidden text-white h-[400px] bg-gray-900 flex items-center">
        <img
          src="https://miro.medium.com/v2/resize:fit:700/0*gtY-llyEbkeoS1Sp.png"
          alt="Java Full Stack Development Background"
          className="absolute inset-0 w-full h-[400px] z-0"
        />

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60 z-10" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 md:py-40 flex flex-col md:flex-row items-center md:items-start">
          <div className="md:w-1/2">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl font-extrabold leading-tight text-left"
            >
              <span className="text-orange-400">Java Full Stack</span> Training in Noida
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="mt-6 text-lg md:text-xl text-gray-200 text-left"
            >
              Become a proficient Java Full Stack Developer. Master enterprise-grade applications, from robust backend services to dynamic front-end interfaces.
            </motion.p>

            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              className="mt-8 "
            >
             <button
                    className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg font-semibold transition text-white"
                     onClick={() => handleOpenPopup("JAVA Full Stack Development Training")} // Pass the course title
                  >
                    Join Now !
                  </button>
            </motion.button>
          </div>
        </div>
      </section>

      {/* Why Learn Java Full Stack Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Why Learn Java Full Stack Development?</h2>
          <p className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto">
            Java Full Stack development is the backbone of enterprise applications worldwide. It offers unparalleled robustness, scalability, and a vast ecosystem, making certified Java Full Stack developers highly sought after.
          </p>
          <div className="grid md:grid-cols-3 gap-8 mt-10">
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-orange-700 mb-3">Enterprise Standard</h3>
              <p className="text-gray-600">Powering large-scale, mission-critical applications across industries.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-orange-700 mb-3">Robust Ecosystem</h3>
              <p className="text-gray-600">Leverage powerful frameworks like Spring Boot, Hibernate, and a rich toolset.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-orange-700 mb-3">High Demand & Salaries</h3>
              <p className="text-gray-600">Constantly growing demand for skilled Java Full Stack developers globally.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Course Highlights Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-blue-900">Course Highlights</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: '🚀', title: 'End-to-End Project Development', desc: 'Build complex web applications using Java, Spring Boot, Hibernate, and frontend frameworks.' },
              { icon: '💡', title: 'Master Core & Advanced Java', desc: 'From Java fundamentals to advanced J2EE concepts and design patterns.' },
              { icon: '👨‍🏫', title: 'Expert-Led Training', desc: 'Learn from seasoned Java architects and full stack developers.' },
              { icon: '🎓', title: 'Industry-Recognized Certification', desc: 'Receive a prestigious certificate validating your full stack expertise.' },
              { icon: '🤝', title: 'Dedicated Placement Support', desc: 'Comprehensive assistance for resume building, mock interviews, and job placements in top companies.' },
              { icon: '🔄', title: 'Flexible Learning Modes', desc: 'Choose between dynamic offline classroom sessions or interactive online live classes.' },
            ].map((item, index) => (
              <motion.div
                key={index}
                className="bg-blue-50 p-6 rounded-lg shadow-md flex items-start space-x-4"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="text-4xl">{item.icon}</div>
                <div>
                  <h3 className="font-semibold text-xl text-blue-800 mb-2">{item.title}</h3>
                  <p className="text-gray-700">{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Curriculum Overview Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-blue-900">Detailed Curriculum Overview</h2>
          <div className="space-y-4">
            {curriculumContent.map((module, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {module.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{module.description}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tools & Technologies */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Tools & Technologies You'll Master</h2>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
            Our Java Full Stack training ensures you gain proficiency in all essential technologies for enterprise-grade web development.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-center">
            {[
              { name: 'Java', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg' },
              { name: 'Spring Boot', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg' },
              { name: 'Hibernate', logo: 'https://www.vectorlogo.zone/logos/hibernate/hibernate-icon.svg' },
              { name: 'MySQL', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' },
              { name: 'PostgreSQL', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' },
              { name: 'Maven', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/maven/maven-original.svg' },
              { name: 'Git', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg' },
              { name: 'IntelliJ IDEA', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/intellij/intellij-original.svg' },
              { name: 'VS Code', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg' },
              { name: 'Tomcat', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tomcat/tomcat-original.svg' },
              { name: 'Postman', logo: 'https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg' },
              { name: 'React (Basics)', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
              { name: 'Angular (Basics)', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg' },
              { name: 'Docker (Basics)', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' },
            ].map((tool, index) => (
              <motion.div
                key={index}
                className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-sm"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <img src={tool.logo} alt={tool.name} className="h-12 mb-2" />
                <p className="text-gray-700 font-medium text-sm">{tool.name}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Career Opportunities */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Exciting Career Opportunities</h2>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
            A Java Full Stack certification from us opens doors to high-demand roles in leading tech companies.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: '🌟', title: 'Java Full Stack Developer', desc: 'Develop end-to-end enterprise applications using Java and related frameworks.' },
              { icon: '💻', title: 'Backend Java Developer', desc: 'Specialize in server-side logic, APIs, and database interactions with Java and Spring Boot.' },
              { icon: '🌐', title: 'Enterprise Java Developer', desc: 'Focus on building robust, scalable applications for large organizations.' },
              { icon: '✨', title: 'Spring Boot Developer', desc: 'Expert in developing microservices and APIs with the Spring Boot framework.' },
              { icon: '🚀', title: 'Microservices Developer', desc: 'Design and implement distributed systems using Java and microservices principles.' },
              { icon: '🛠️', title: 'Software Architect (Java)', desc: 'Plan and oversee the architecture of complex Java-based software solutions.' },
            ].map((role, index) => (
              <motion.div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center text-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="text-5xl mb-4">{role.icon}</div>
                <h3 className="font-semibold text-xl text-blue-800 mb-2">{role.title}</h3>
                <p className="text-gray-700">{role.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center md:text-left">Frequently Asked Questions</h2>
          <div className="space-y-4">
            {faqContent.map((section, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {section.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{section.answer}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>

        {/* Enquiry Form */}
        <div className="md:col-span-1 pt-20">
          <div className="bg-gray-100 rounded-lg p-6 shadow-xl">
            <h3 className="text-2xl font-bold mb-4 text-center text-blue-800">
              Enquire Now
            </h3>
            <p className="text-center text-gray-600 mb-6">
              Fill out the form below to get more details about our Java Full Stack training program.
            </p>
            <form className="space-y-4" onSubmit={handleSubmit}>
              <input
                type="text"
                name="firstName"
                placeholder="Your Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.firstName}
                onChange={handleInputChange}
                required
              />
              <input
                type="text"
                name="courseOfInterest"
                placeholder="Course of Interest (e.g., Java Full Stack)"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.courseOfInterest}
                onChange={handleInputChange}
                required
              />
              <input
                type="text"
                name="collegeName"
                placeholder="College/University Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.collegeName}
                onChange={handleInputChange}
              />
              <input
                type="email"
                name="businessEmail"
                placeholder="Your Email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.businessEmail}
                onChange={handleInputChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
              <button
                type="submit"
                className="w-full bg-blue-800 hover:bg-blue-700 text-white py-3 rounded-md font-semibold transition duration-300 ease-in-out shadow-md hover:shadow-lg"
              >
                JOIN THE PROGRAM
              </button>
              {formStatus.submitted && (
                <div
                  className={`mt-4 p-3 rounded-md text-center ${
                    formStatus.type === "success"
                      ? "bg-green-100 text-green-800"
                      : "bg-red-100 text-red-800"
                  }`}
                >
                  {formStatus.message}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Testimonial Section - No Horizontal Scrollbar */}
      <section className="bg-orange-50 py-16">
        <div className="max-w-7xl mx-auto px-4 text-center relative">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-orange-900">
            Hear From Our Java Full Stack Graduates
          </h2>

          <div className="relative overflow-hidden w-full mx-auto">
            {/* Left Scroll Button */}
            <button
              onClick={goToPrevTestimonial}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Previous testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>

            {/* Testimonial Cards Container */}
            <div className="flex justify-center items-stretch space-x-6 md:space-x-8 lg:space-x-10">
              <AnimatePresence mode="wait" initial={false}>
                {currentVisibleTestimonials.map((testimonial, idx) => (
                  <motion.div
                    key={testimonial.id} // Key by testimonial ID for consistent animation
                    initial={{ opacity: 0, x: idx * 100 }} // Initial position based on index in visible set
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className="flex-none w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-2rem)] p-2"
                  >
                    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 flex flex-col h-full text-left">
                      <div className="flex items-center mb-4">
                        <img
                          src={testimonial.profileImg}
                          alt={testimonial.name}
                          className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-orange-200"
                        />
                        <div>
                          <p className="font-bold text-gray-900 text-lg">
                            {testimonial.name}
                          </p>
                          <p className="text-gray-500 text-sm">
                            {testimonial.date} • {testimonial.source}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center mb-3">
                        <StarRating rating={testimonial.rating} />
                        {testimonial && <VerifiedBadge />}
                      </div>
                      <p className="text-gray-700 text-base leading-relaxed flex-grow line-clamp-4">
                        {testimonial.review}
                      </p>
                      <a
                        href="#"
                        className="text-orange-600 hover:underline mt-4 text-sm text-right"
                      >
                        Read more
                      </a>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            {/* Right Scroll Button */}
            <button
              onClick={goToNextTestimonial}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Next testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                className={`h-3 w-3 rounded-full ${
                  // Logic to highlight dots based on the current set of visible testimonials
                  idx >= currentTestimonialIndex &&
                  idx < currentTestimonialIndex + visibleCount
                    ? "bg-orange-600"
                    : "bg-gray-300"
                } transition-colors duration-300`}
                onClick={() => setCurrentTestimonialIndex(idx)}
                aria-label={`Go to testimonial group ${idx + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </section>

       {/* Conditionally render the popup */}
      {isPopupOpen && (
        <JoinNowFormPopup
          onClose={handleClosePopup}
          courseTitle={selectedCourseTitle}
        />
      )} 
    </div>
  );
};

export default JAVAFullStackInNoida;